import { api } from './emptyApi'

export const addTagTypes = ['Meters', 'Solar Arrays', 'Batteries'] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      listMeterSims: build.query<ListMeterSimsResponse, ListMeterSimsArgs>({
        query: () => ({ url: `/api/der-simulator/meters` }),
        providesTags: ['Meters']
      }),
      createMeterSim: build.mutation<CreateMeterSimResponse, CreateMeterSimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/meters`, method: 'POST', body: queryArg.meterSimConfig }),
        invalidatesTags: ['Meters']
      }),
      getMeterSim: build.query<GetMeterSimResponse, GetMeterSimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/meters/${queryArg.entityId}` }),
        providesTags: ['Meters']
      }),
      deleteMeterSim: build.mutation<DeleteMeterSimResponse, DeleteMeterSimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/meters/${queryArg.entityId}`, method: 'DELETE' }),
        invalidatesTags: ['Meters']
      }),
      listSolarArraySims: build.query<ListSolarArraySimsResponse, ListSolarArraySimsArgs>({
        query: () => ({ url: `/api/der-simulator/solar-arrays` }),
        providesTags: ['Solar Arrays']
      }),
      createSolarArraySim: build.mutation<CreateSolarArraySimResponse, CreateSolarArraySimArgs>({
        query: (queryArg) => ({
          url: `/api/der-simulator/solar-arrays`,
          method: 'POST',
          body: queryArg.solarArraySimConfig
        }),
        invalidatesTags: ['Solar Arrays']
      }),
      getSolarArraySim: build.query<GetSolarArraySimResponse, GetSolarArraySimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/solar-arrays/${queryArg.entityId}` }),
        providesTags: ['Solar Arrays']
      }),
      updateSolarArraySim: build.mutation<UpdateSolarArraySimResponse, UpdateSolarArraySimArgs>({
        query: (queryArg) => ({
          url: `/api/der-simulator/solar-arrays/${queryArg.entityId}`,
          method: 'PUT',
          body: queryArg.solarArraySimConfig
        }),
        invalidatesTags: ['Solar Arrays']
      }),
      deleteSolarArraySim: build.mutation<DeleteSolarArraySimResponse, DeleteSolarArraySimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/solar-arrays/${queryArg.entityId}`, method: 'DELETE' }),
        invalidatesTags: ['Solar Arrays']
      }),
      sendSolarArrayCommand: build.mutation<SendSolarArrayCommandResponse, SendSolarArrayCommandArgs>({
        query: (queryArg) => ({
          url: `/api/der-simulator/solar-arrays/${queryArg.entityId}/commands`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Solar Arrays']
      }),
      listBatterySims: build.query<ListBatterySimsResponse, ListBatterySimsArgs>({
        query: () => ({ url: `/api/der-simulator/batteries` }),
        providesTags: ['Batteries']
      }),
      createBatterySim: build.mutation<CreateBatterySimResponse, CreateBatterySimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/batteries`, method: 'POST', body: queryArg.batterySimConfig }),
        invalidatesTags: ['Batteries']
      }),
      getBatterySim: build.query<GetBatterySimResponse, GetBatterySimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/batteries/${queryArg.entityId}` }),
        providesTags: ['Batteries']
      }),
      updateBatterySim: build.mutation<UpdateBatterySimResponse, UpdateBatterySimArgs>({
        query: (queryArg) => ({
          url: `/api/der-simulator/batteries/${queryArg.entityId}`,
          method: 'PUT',
          body: queryArg.batterySimConfig
        }),
        invalidatesTags: ['Batteries']
      }),
      deleteBatterySim: build.mutation<DeleteBatterySimResponse, DeleteBatterySimArgs>({
        query: (queryArg) => ({ url: `/api/der-simulator/batteries/${queryArg.entityId}`, method: 'DELETE' }),
        invalidatesTags: ['Batteries']
      }),
      sendBatteryCommand: build.mutation<SendBatteryCommandResponse, SendBatteryCommandArgs>({
        query: (queryArg) => ({
          url: `/api/der-simulator/batteries/${queryArg.entityId}/commands`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Batteries']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type ListMeterSimsResponse = /** status 200 Successful Response */ MeterSimSummary[]
export type ListMeterSimsArgs = void
export type CreateMeterSimResponse = /** status 201 Successful Response */ MeterSimSummary
export type CreateMeterSimArgs = {
  meterSimConfig: MeterSimConfig
}
export type GetMeterSimResponse = /** status 200 Successful Response */ MeterSimDetail
export type GetMeterSimArgs = {
  entityId: string
}
export type DeleteMeterSimResponse = unknown
export type DeleteMeterSimArgs = {
  entityId: string
}
export type ListSolarArraySimsResponse = /** status 200 Successful Response */ SolarArraySimSummary[]
export type ListSolarArraySimsArgs = void
export type CreateSolarArraySimResponse = /** status 201 Successful Response */ SolarArraySimSummary
export type CreateSolarArraySimArgs = {
  solarArraySimConfig: SolarArraySimConfig
}
export type GetSolarArraySimResponse = /** status 200 Successful Response */ SolarArraySimDetail
export type GetSolarArraySimArgs = {
  entityId: string
}
export type UpdateSolarArraySimResponse = /** status 200 Successful Response */ SolarArraySimDetail
export type UpdateSolarArraySimArgs = {
  entityId: string
  solarArraySimConfig: SolarArraySimConfig
}
export type DeleteSolarArraySimResponse = unknown
export type DeleteSolarArraySimArgs = {
  entityId: string
}
export type SendSolarArrayCommandResponse = /** status 200 Successful Response */ SolarArraySimCommandResult
export type SendSolarArrayCommandArgs = {
  entityId: string
  body: InjectFaultCommand | ClearFaultCommand
}
export type ListBatterySimsResponse = /** status 200 Successful Response */ BatterySimSummary[]
export type ListBatterySimsArgs = void
export type CreateBatterySimResponse = /** status 201 Successful Response */ BatterySimSummary
export type CreateBatterySimArgs = {
  batterySimConfig: BatterySimConfig
}
export type GetBatterySimResponse = /** status 200 Successful Response */ BatterySimDetail
export type GetBatterySimArgs = {
  entityId: string
}
export type UpdateBatterySimResponse = /** status 200 Successful Response */ BatterySimDetail
export type UpdateBatterySimArgs = {
  entityId: string
  batterySimConfig: BatterySimConfig
}
export type DeleteBatterySimResponse = unknown
export type DeleteBatterySimArgs = {
  entityId: string
}
export type SendBatteryCommandResponse = /** status 200 Successful Response */ BatterySimCommandResult
export type SendBatteryCommandArgs = {
  entityId: string
  body: SetSetpointCommand | ClearSetpointCommand
}
export type MeterSimSummary = {
  entity_id: string
  thing_name: string
  profile_name: string
  publish_interval_seconds: number
  status: 'running' | 'stopped'
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
  ctx?: object
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type MeterSimConfig = {
  entity_id: string
  thing_name: string
  profile_name: string
  profile_params: {
    [key: string]: unknown
  }
  /** Seconds between simulated meter readings. */
  publish_interval_seconds: number
}
export type MeterSimDetail = {
  entity_id: string
  thing_name: string
  profile_name: string
  publish_interval_seconds: number
  status: 'running' | 'stopped'
  profile_params: {
    [key: string]: unknown
  }
}
export type SolarAlarmCode =
  | 'GROUND_FAULT'
  | 'DC_OVER_VOLT'
  | 'AC_DISCONNECT'
  | 'DC_DISCONNECT'
  | 'GRID_DISCONNECT'
  | 'CABINET_OPEN'
  | 'MANUAL_SHUTDOWN'
  | 'OVER_TEMP'
  | 'OVER_FREQUENCY'
  | 'UNDER_FREQUENCY'
  | 'AC_OVER_VOLT'
  | 'AC_UNDER_VOLT'
  | 'BLOWN_STRING_FUSE'
  | 'UNDER_TEMP'
  | 'MEMORY_LOSS'
  | 'HW_TEST_FAILURE'
export type SolarArraySimSummary = {
  entity_id: string
  thing_name: string
  profile_name: string
  publish_interval_seconds: number
  status: 'running' | 'stopped'
  active_fault_codes?: SolarAlarmCode[]
}
export type SolarArraySimConfig = {
  entity_id: string
  thing_name: string
  profile_name: string
  profile_params: {
    [key: string]: unknown
  }
  /** Seconds between simulated solar snapshot publishes. */
  publish_interval_seconds: number
}
export type SolarArraySimDetail = {
  entity_id: string
  thing_name: string
  profile_name: string
  publish_interval_seconds: number
  status: 'running' | 'stopped'
  active_fault_codes?: SolarAlarmCode[]
  profile_params: {
    [key: string]: unknown
  }
}
export type SolarArraySimCommandResult = {
  entity_id: string
  action: string
  active_fault_codes: SolarAlarmCode[]
}
export type InjectFaultCommand = {
  action: 'inject_fault'
  code: SolarAlarmCode
  /** Auto-clear the fault this many seconds after injection. Omit to leave it active until cleared. */
  auto_clear_seconds?: number | null
}
export type ClearFaultCommand = {
  action: 'clear_fault'
  code?: SolarAlarmCode | null
}
export type BatterySimSummary = {
  entity_id: string
  thing_name: string
  capacity_kwh: number
  publish_interval_seconds: number
  status: 'running' | 'stopped'
  soc: number
}
export type BatterySimConfig = {
  entity_id: string
  thing_name: string
  capacity_kwh: number
  max_charge_power_kw: number
  max_discharge_power_kw: number
  round_trip_efficiency?: number
  initial_soc?: number
  min_soc?: number
  max_soc?: number
  self_discharge_pct_per_day?: number
  nominal_voltage?: number
  /** Seconds between simulated battery snapshot publishes. */
  publish_interval_seconds: number
}
export type BatterySimSetpoint = {
  mode: 'charge' | 'discharge'
  power_kw: number
  expires_at?: string | null
}
export type BatterySimDetail = {
  entity_id: string
  thing_name: string
  capacity_kwh: number
  publish_interval_seconds: number
  status: 'running' | 'stopped'
  soc: number
  max_charge_power_kw: number
  max_discharge_power_kw: number
  round_trip_efficiency: number
  initial_soc: number
  min_soc: number
  max_soc: number
  self_discharge_pct_per_day: number
  nominal_voltage: number
  applied_power_kw: number
  active_setpoint?: BatterySimSetpoint | null
}
export type BatterySimCommandResult = {
  entity_id: string
  action: string
  active_setpoint?: BatterySimSetpoint | null
}
export type SetSetpointCommand = {
  action: 'set_setpoint'
  mode: 'charge' | 'discharge'
  power_kw: number
  /** Return to idle this many seconds after the command. Omit to hold the setpoint until replaced or cleared. */
  duration_seconds?: number | null
}
export type ClearSetpointCommand = {
  action: 'clear_setpoint'
}
export const {
  useListMeterSimsQuery,
  useLazyListMeterSimsQuery,
  useCreateMeterSimMutation,
  useGetMeterSimQuery,
  useLazyGetMeterSimQuery,
  useDeleteMeterSimMutation,
  useListSolarArraySimsQuery,
  useLazyListSolarArraySimsQuery,
  useCreateSolarArraySimMutation,
  useGetSolarArraySimQuery,
  useLazyGetSolarArraySimQuery,
  useUpdateSolarArraySimMutation,
  useDeleteSolarArraySimMutation,
  useSendSolarArrayCommandMutation,
  useListBatterySimsQuery,
  useLazyListBatterySimsQuery,
  useCreateBatterySimMutation,
  useGetBatterySimQuery,
  useLazyGetBatterySimQuery,
  useUpdateBatterySimMutation,
  useDeleteBatterySimMutation,
  useSendBatteryCommandMutation
} = injectedRtkApi
